window.manifest = window.manifest || {};
manifest.clicked = false;
const rangeInput = document.querySelectorAll(".range-input input"),
priceSelectd = document.querySelector(".manifest-ymm-selected-price"),
range = document.querySelector(".slider .progress");
let priceGap = 500;

// Throttle function
let throttleTimeout; // Timeout for throttling
let lastMin, lastMax; // Variables to store the latest values
const throttleDelay = 300; // Throttle delay in milliseconds

function throttleUpdate(min, max) {
  // Update the last captured values
  lastMin = min;
  lastMax = max;

  if (!throttleTimeout) {
    throttleTimeout = setTimeout(() => {
      // Use the latest captured values for the API call
      updateFilters({ 'max_price': lastMax, 'min_price': lastMin });
      throttleTimeout = null;
    }, throttleDelay);
  }
}

rangeInput.forEach((input) => {
  input.addEventListener("input", (e) => {
    let minVal = parseInt(rangeInput[0].value),
      maxVal = parseInt(rangeInput[1].value);
    if (maxVal - minVal < priceGap) {
      if (e.target.className === "range-min") {
        rangeInput[0].value = maxVal - priceGap;
      } else {
        rangeInput[1].value = minVal + priceGap;
      }
    } else {
      // Update UI elements
      priceSelectd.innerHTML = `$${minVal} - $${maxVal}`;
      range.style.left = `calc(${(minVal / rangeInput[0].max) * 100}% + 15px)`;
      range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
    }
    throttleUpdate(minVal, maxVal);
  });
});


//start custom dropdown
const selectedAll = document.querySelectorAll(".wrapper-dropdown");

// Toggle dropdowns on click
selectedAll.forEach((selected) => {
  const arrow = selected.children[1];
  const optionsList = selected.querySelectorAll("div.wrapper-dropdown li");

  selected.addEventListener("click", () => {
    if (selected.classList.contains("active")) {
      handleDropdown(selected, arrow, false);
    } else {
      const currentActive = document.querySelector(".wrapper-dropdown.active");
      if (currentActive && currentActive !== selected) {
        const anotherArrow = currentActive.children[1];
        handleDropdown(currentActive, anotherArrow, false);
      }
      handleDropdown(selected, arrow, true);
    }
  });

  // Update the selected display and handle item click
  optionsList.forEach((o) => {
    o.addEventListener("click", () => {
      selected.querySelector(".selected-display").innerHTML = o.innerHTML;
      selected.querySelectorAll(".dropdown li").forEach((listItem) => {
        listItem.classList.remove("active");
      });
      o.classList.add("active");
    });
  });
});

// Close all dropdowns when clicking outside
window.addEventListener("click", (e) => {
  if (!e.target.closest(".wrapper-dropdown") && !e.target.closest("#manifest_ymm_sort_by")) {
    closeAllDropdowns();
  }
});

// Close all dropdowns
function closeAllDropdowns() {
  selectedAll.forEach((selected) => {
    const arrow = selected.children[1];
    handleDropdown(selected, arrow, false);
  });
}

// Handle dropdown toggle
function handleDropdown(dropdown, arrow, open) {
  if (open) {
    arrow.classList.add("rotated");
    dropdown.classList.add("active");
  } else {
    arrow.classList.remove("rotated");
    dropdown.classList.remove("active");
  }
}
//End custom dropdown

// Add click event to filter tabs
document.querySelectorAll('.manifest-ymm-filter-tab li').forEach(function(tabLink) {
    tabLink.addEventListener('click', function(event) {
        event.preventDefault();

        // Toggle active state for tabs
        document.querySelectorAll('.manifest-ymm-filter-tab li').forEach(link => link.classList.remove('active'));
        this.classList.add('active');

        // Toggle active state for content
        const target = this.getAttribute('data-rel');
        document.querySelectorAll('.manifest-ymm-filter-item').forEach(item => item.classList.remove('active'));
        const targetElement = document.getElementById(target);
        if (targetElement) targetElement.classList.add('active');
    });
});

// Add event listeners to all search inputs
document.querySelectorAll('.search-input').forEach((searchInput) => {
  searchInput.addEventListener('keyup', (e) => {
    // Get the parent container of the search input
    const container = searchInput.closest('.search-container');
    
    // Find all titles within the same container
    const titles = container.querySelectorAll('.manifest-ymm-filter-list li');

    // Get the search term from the input
    const searchTerm = e.target.value.toLowerCase();

    // Filter titles based on the search term
    titles.forEach((title) => {
      const titleText = title.textContent.toLowerCase();
      titleText.includes(searchTerm)
        ? (title.style.display = 'block')
        : (title.style.display = 'none');
    });
  });
});

// Add click event for filter open/close actions
document.addEventListener('click', function(event) {
  const filters = document.querySelector('.manifest-ymm-filters');
  const footer = document.querySelector('.manifest-ymm-filter-footer');  
  if (!manifest.clicked) {
    manifest.clicked = true;
    if (event.target.id === 'manifest_ymm_filter_open') {
        filters.classList.add('active');
        footer.classList.add('hide');
    } else if (event.target.id === 'filter_close' || event.target.id === 'filter_apply') {
        filters.classList.remove('active');
        footer.classList.remove('hide');
    } else if (event.target.classList.contains('manifest-ymm-filter-show-more')) {
        event.target.closest('.manifest-ymm-filter-item')
            .querySelector('.manifest-ymm-filter-show-more-wrap')
            .classList.add('active');
    }else if (event.target.closest(".manifest-ymm-filter-show-more-wrap") === null) {
      const showMoreAll = document.querySelectorAll(".manifest-ymm-filter-show-more-wrap");
      showMoreAll.forEach((showMore) => {
        showMore.classList.remove('active');
      });
    }
    if (event.target.classList.contains("icon-search") && event.target.closest(".manifest-ymm-filter-search") != null) {
      event.target.closest(".manifest-ymm-filter-search").classList.add('active');
      event.target.closest(".manifest-ymm-filter-search").querySelector('input').focus();
    }
    if (event.target.classList.contains("icon-close") && event.target.closest(".manifest-ymm-filter-search") != null) {
      event.target.closest(".manifest-ymm-filter-search").classList.remove('active');
      const inputElement = event.target.closest(".manifest-ymm-filter-search").querySelector('input');
      inputElement.value = '';
      inputElement.dispatchEvent(new Event('keyup'));
    }
    setTimeout(() => {
      manifest.clicked = false;
    }, 500);
  }
});

function collectionFilterList(collection,sanitizedTitle,selectedResources) {

  if(sanitizedTitle == '' || sanitizedTitle == null){
    return ``;
  }

  let is_checked = "";
  if (typeof selectedResources != 'undefined' && selectedResources != null) {
    is_checked = selectedResources.includes(String(collection.id)) ? "checked" : "";
  }
  
  return `<li>
      <label for="Filter-Categories-${sanitizedTitle}" class="manifest-ymm-checkbox">
          <input type="checkbox" name="Categories" value="${collection.id}" id="Filter-Categories-${sanitizedTitle}" ${is_checked}>
          <svg width="1.6rem" height="1.6rem" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
              <rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect>
          </svg>
          <svg class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          ${sanitizedTitle}
      </label>
  </li>`;
}
function filterList(sanitizedTitle,resourceType , selectedResources) { 

  if(sanitizedTitle == '' || sanitizedTitle == null){
    return ``;
  }
  
  let is_checked = "";
  if (typeof selectedResources != 'undefined' && selectedResources != null) {
    is_checked = selectedResources.includes(sanitizedTitle) ? "checked" : "";
  }
  
  return `<li>
      <label for="Filter-Categories-x-${sanitizedTitle}" class="manifest-ymm-checkbox">
          <input type="checkbox" name="`+resourceType+`" value="${sanitizedTitle}" id="Filter-Categories-x-${sanitizedTitle}" ${is_checked}>
          <svg width="1.6rem" height="1.6rem" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
              <rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect>
          </svg>
          <svg class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          ${sanitizedTitle}
      </label>
  </li>`;
}

function productGridItem(product){
  let productHTML = '';
  productHTML = `<li class="grid__item">
                <div class="card-wrapper underline-links-hover">
                  <div class="card card--standard card--media " style="--ratio-percent: 100.0%;">
                    <div class="card__inner color-background-1 ratio" style="--ratio-percent: 100.0%;">
                      <div class="card__media">
                        <div class="media media--transparent media--hover-effect hrer">
                          <img src="`+product.image+`" alt="" width="1500" height="1500">
                          <img src="`+product.image+`" alt="" loading="lazy" width="1500" height="1500">
                        </div>
                      </div>`;
  if(product.tags.indexOf('in_stock') == -1){
  productHTML += `<div class="card__content">
                        <div class="card__badge bottom right">
                          <span class="badge badge--bottom-left color-inverse">Sold out</span>
                        </div>
                      </div>`;
  }
  productHTML += `</div>
                    <div class="card__content">
                      <div class="card__information">
                        <h3 class="card__heading h5">
                          <a href="/products/`+product.handle+`" class="full-unstyled-link">
                            `+product.title+`
                          </a>
                        </h3>
                        <div class="card-information">
                          <div class="price price--sold-out">
                            <div class="price__container"><div class="price__regular">
                                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                <span class="price-item price-item--regular">
                                  $`+product.price+` USD
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>`;
  return productHTML;
}

function extractPageNumber(url) {
  if (!url) return null;
  try {
    const urlObj = new URL(url);
    return urlObj.searchParams.get('page');
  } catch (e) {
    return null;
  }
}

function getPaginationHtmlContent(links) {
  let html = '<ul class="pagination-ymm">';
  $.each(links, (index, link) => {
    const activeClass = link.active ? 'active' : '';
    const disabledClass = link.url === null ? 'disabled' : '';
    const pageNumber = extractPageNumber(link.url);
    html += `
      <li class="page-item ${activeClass} ${disabledClass}" data-page="${pageNumber || ''}">
        <span class="page-link">${link.label}</span>
      </li>
    `;
  });
  html += '</ul>';
  return html;
}

$(document).ready(function(){
    if (applied_filters.year && applied_filters.make && applied_filters.model) {
      getApiData();
    }else{
      $('.open-ymm-modal')[0].click();
    }

    if (typeof applied_filters === 'object' && applied_filters !== null) {
        const minPrice = applied_filters.min_price ?? 0;
        const maxPrice = applied_filters.max_price ?? 50000; 
    
        if ($('.range-max').length) {
            $('.range-max').val(maxPrice).trigger('change');
        }
    
        if ($('.range-min').length) {
            $('.range-min').val(minPrice).trigger('change');
        }
    
        if ($('.manifest-ymm-selected-price').length) {
            $('.manifest-ymm-selected-price').text(`$${minPrice} - $${maxPrice}`);
        }
    } else {
        console.error('applied_filters is not a valid object');
    }  
});

$(document).on('click','.page-item',function(){
  if(!$(this).hasClass('disabled')){
    applied_filters.page = $(this).attr('data-page');
  }
});

$(document).on('click','li.ymm-sort-option',function(){
    updateFilters({  my_sort_by : $(this).attr('sort-by') , my_sort_order : $(this).attr('sort-order') , page : 1 });
});

$(document).on('change', 'input[name="Categories"]', function() {
  const selectedValues = $('input[name="Categories"]:checked').map(function() { return this.value; }).get();
  applied_filters.my_collection_id = selectedValues;
});

$(document).on('change', 'input[name="brands"]', function() {
  const selectedBrands = $('input[name="brands"]:checked').map(function() { return this.value; }).get();
  applied_filters.my_brand = selectedBrands;
});

$(document).on('change', 'input[name="product_types"]', function() {
  const selectedProductTypes = $('input[name="product_types"]:checked').map(function() { return this.value; }).get();
  applied_filters.my_product_type = selectedProductTypes;
});

$(document).on('click','.manifest-ymm-filter-clearAllBtn',function(){
    updateFilters({ page: 1, my_collection_id : null , my_sort_by : null , my_sort_order : null , my_product_type : null ,  my_brand : null });
    const filters = document.querySelector('.manifest-ymm-filters').classList.remove('active');
    const footer = document.querySelector('.manifest-ymm-filter-footer').classList.remove('hide');  
});

$(document).on('click','#manifest_ymm_sort_by',function(){
  document.querySelector('.manifest-ymm-products-sort-select .wrapper-dropdown').click();
});
